module.exports = {
  src: __webpack_public_path__ + "assets/images/join-plus.46b0c831d9d55aa9.svg",
  width: 25,
  height: 25,
  toString: function() { return __webpack_public_path__ + "assets/images/join-plus.46b0c831d9d55aa9.svg"; }
};